import api from './data.services'
import { authService } from '.'

const adsSrv = 'ads'
const adsFilterSrv = 'ads/pages'
const adsDeleteSrv = 'ads/disabled'
const adsEnableSrv = 'ads/enabled'

const getAds = async () => {
  try {
    const resp: any = await api.get(adsSrv, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.ads ? resp.data.ads : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener anuncios!'
    }
  }
}

const getAdsSearch = async (filter: string, page: number = 1, limit: number = 10) => {
  try {
    const resp: any = await api.post(
      adsFilterSrv,
      {
        filter,
        page,
        limit
      },
      authService.getToken()
    )

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch (error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener anuncios!'
    }
  }
}

const getAdById = async (adId: number) => {
  try {
    const resp: any = await api.get(`${adsSrv}/${adId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.ads ? resp.data.ads : null)
    }
  } catch (error) {
    return {
      status: 'Error',
      data: null,
      message: 'Error server al obtener anuncio!'
    }
  }
}

const postAd = async (data: any) => {
  try {
    const resp: any = await api.post(adsSrv, data, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al guardar anuncio!'
    }
  }
}

const updateAd = async (data: any, adId: number) => {
  try {
    const resp: any = await api.put(`${adsSrv}/${adId}`, data, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error: any) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al actualizar anuncio!'
    }
  }
}

const delAd = async (adId: number) => {
  try {
    let resp: any = await api.del(adsDeleteSrv, adId, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al deshabilitar anuncio!'
    }
  }
}

const enableAd = async (adId: number) => {
  try {
    let resp: any = await api.del(adsEnableSrv, adId, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al habilitar anuncio!'
    }
  }
}

export const adsService = {
  getAds,
  getAdsSearch,
  getAdById,
  postAd,
  updateAd,
  delAd,
  enableAd
}